export const BRAND = {
  name: "Baba Tour",
  fullName: "Baba Tour Umroh & Haji Khusus",
  tagline: "Sahabat Perjalanan Umroh Anda",
  phone: "+62 823 9215 6538",
  phoneRaw: "6282392156538",
  email: "babatour.batam@gmail.com",
  address: "Ruko Mega Legenda 2 Blok B2 No 26, Batam",
  city: "Batam, Kepulauan Riau, Indonesia",
  facebook: "https://www.facebook.com/people/BabatourBatam/61572145778044/",
  instagram: "https://www.instagram.com/babatour.batam/",
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "packages", label: "Packages" },
  { id: "about", label: "About" },
  { id: "services", label: "Why Us" },
  { id: "gallery", label: "Gallery" },
  { id: "testimonials", label: "Testimonials" },
  { id: "faq", label: "FAQ" },
];

export const PACKAGES = [
  {
    id: "umrah-economy",
    name: "Umrah Ekonomi",
    duration: "9 Days",
    departures: "Bulanan • Jan – Dec 2026",
    priceFrom: "Rp 28,900,000",
    hotelMakkah: "Hotel ★★★★ — 700m from Masjidil Haram",
    hotelMadinah: "Hotel ★★★★ — 300m from Masjid Nabawi",
    airline: "Saudia / Garuda Indonesia",
    image:
      "https://images.unsplash.com/photo-1704104501136-8f35402af395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxrYWFiYSUyMG1lY2NhfGVufDB8fHx8MTc4MDE4MjY2NHww&ixlib=rb-4.1.0&q=85",
    badge: "Best Value",
    includes: [
      "Tiket pesawat PP (Jakarta/Batam)",
      "Hotel bintang 4 di Makkah & Madinah",
      "Visa umroh resmi",
      "Manasik & bimbingan ibadah",
      "Muthawif berbahasa Indonesia",
      "Perlengkapan eksklusif",
    ],
  },
  {
    id: "umrah-vip",
    name: "Umrah VIP",
    duration: "12 Days",
    departures: "Setiap minggu • Premium",
    priceFrom: "Rp 39,500,000",
    hotelMakkah: "Hotel ★★★★★ — 50m from Masjidil Haram",
    hotelMadinah: "Hotel ★★★★★ — 100m from Masjid Nabawi",
    airline: "Saudia / Emirates (Direct)",
    image:
      "https://images.pexels.com/photos/34498854/pexels-photo-34498854.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    badge: "Premium",
    includes: [
      "Penerbangan langsung kelas bintang 5",
      "Hotel bintang 5 dekat haram",
      "Visa umroh resmi & express",
      "City tour Madinah & Makkah",
      "Pembimbing ulama berpengalaman",
      "Kuota terbatas, pelayanan personal",
    ],
  },
  {
    id: "umrah-plus",
    name: "Umrah Plus Turki",
    duration: "14 Days",
    departures: "Mar • May • Sep • Nov 2026",
    priceFrom: "Rp 45,000,000",
    hotelMakkah: "Hotel ★★★★★ — Pullman Zamzam area",
    hotelMadinah: "Hotel ★★★★★ — Anwar Al Madinah",
    airline: "Turkish Airlines (Direct)",
    image:
      "https://images.unsplash.com/photo-1592326871020-04f58c1a52f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxrYWFiYSUyMG1lY2NhfGVufDB8fHx8MTc4MDE4MjY2NHww&ixlib=rb-4.1.0&q=85",
    badge: "Wisata Sejarah",
    includes: [
      "Tour Istanbul: Blue Mosque, Hagia Sophia",
      "Hotel bintang 5 di seluruh perjalanan",
      "Penerbangan Turkish Airlines",
      "Pembimbing ibadah & city guide",
      "Cruise Bosphorus & makan eksklusif",
      "Limited 25 pax per group",
    ],
  },
  {
    id: "haji-khusus",
    name: "Haji Khusus 2027",
    duration: "26 Days",
    departures: "Musim Haji 1448 H",
    priceFrom: "USD 13,500",
    hotelMakkah: "Hotel ★★★★★ — Zamzam Tower",
    hotelMadinah: "Hotel ★★★★★ — Dar Al Iman Intercontinental",
    airline: "Saudia (Direct)",
    image:
      "https://images.pexels.com/photos/29102893/pexels-photo-29102893.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    badge: "Resmi Kemenag",
    includes: [
      "Kuota Haji Khusus resmi Kemenag",
      "Tenda Mina & Arafah AC khusus",
      "Catering Indonesia 3x sehari",
      "Bimbingan ulama syariah",
      "Manasik intensif 6 bulan",
      "Asuransi perjalanan komprehensif",
    ],
  },
];

export const SERVICES = [
  { icon: "ShieldCheck", title: "Terpercaya", desc: "Travel umroh berizin resmi & terdaftar Kemenag RI." },
  { icon: "UsersRound", title: "Pembimbing Terbaik", desc: "Muthawif & ulama berpengalaman puluhan tahun." },
  { icon: "BedDouble", title: "Hotel Berkualitas", desc: "Hotel bintang 4 & 5 strategis dekat haram." },
  { icon: "BadgeCheck", title: "Pelayanan Resmi", desc: "SOP umroh sesuai standar pemerintah Arab Saudi." },
  { icon: "Clock", title: "On Time", desc: "Maskapai bintang 5 dengan jadwal tepat waktu." },
  { icon: "Sofa", title: "Nyaman", desc: "Armada bus & akomodasi eksklusif penuh kenyamanan." },
  { icon: "Sparkles", title: "Profesional", desc: "Tim berpengalaman melayani ribuan jamaah." },
  { icon: "Gift", title: "Perlengkapan Eksklusif", desc: "Koper, kain ihram, mukena dan suvenir premium." },
];

export const TESTIMONIALS = [
  {
    name: "Yessi Febriantika Handayani",
    package: "Google Review",
    quote:
      "Alhamdulillah, berangkat umroh bersama Baba Tour aman dan terpercaya. Semua kebutuhan tercukupi mulai dari ibadah umroh, hotel, makan, hingga perjalanan selama di Makkah dan Madinah.",
    image: "",
  },
  {
    name: "Ahmad Habibi Kcharis Jaya",
    package: "Google Review",
    quote:
      "Perjalanan umroh bersama Baba Tour berjalan lancar dan khusyuk. Fasilitas baik serta pembimbing yang berpengalaman dan responsif.",
    image: "",
  },
  {
    name: "Dwi Yuliana",
    package: "Google Review",
    quote:
      "Harga hemat dengan pelayanan yang sangat memuaskan. Hotel dekat masjid, makanan enak, dan fasilitas selama perjalanan sangat baik.",
    image: "",
  },
  {
    name: "Nico Abbraham",
    package: "Google Review",
    quote:
      "Pendamping dan muthawif sangat berpengalaman, solutif, serta perhatian kepada jamaah selama perjalanan ibadah.",
    image: "",
  },
];

export const GALLERY = [
  "https://images.pexels.com/photos/8059446/pexels-photo-8059446.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1646228626691-862369e6a787?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxtdXNsaW0lMjBwaWxncmltJTIwcHJheWluZ3xlbnwwfHx8fDE3ODAxODI2NjR8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1575751639353-e292e76daca3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxtdXNsaW0lMjBwaWxncmltJTIwcHJheWluZ3xlbnwwfHx8fDE3ODAxODI2NjR8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/33169789/pexels-photo-33169789.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/18360295/pexels-photo-18360295.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1592326871020-04f58c1a52f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxrYWFiYSUyMG1lY2NhfGVufDB8fHx8MTc4MDE4MjY2NHww&ixlib=rb-4.1.0&q=85",
];

export const FAQ = [
  {
    q: "Berapa DP minimal untuk mendaftar umroh?",
    a: "Pendaftaran umroh di Baba Tour dapat dimulai dengan DP mulai dari Rp5 juta per jamaah. Setelah pembayaran DP, seat dan proses administrasi dapat langsung diamankan sesuai ketentuan paket yang dipilih.",
  },

  {
    q: "Apakah pembayaran bisa dicicil?",
    a: "Ya. Baba Tour menyediakan sistem cicilan hingga waktu keberangkatan. Jamaah dapat mencicil secara bertahap sesuai kemampuan tanpa harus melunasi seluruh biaya di awal.",
  },

  {
    q: "Keberangkatan tersedia dari kota mana saja?",
    a: "Saat ini tersedia keberangkatan dari Batam, Palembang, serta Batam via Singapore (Bandara Changi) untuk beberapa paket tertentu. Detail kota keberangkatan dapat dilihat pada masing-masing paket.",
  },

  {
    q: "Apakah hotel yang digunakan dekat dengan Masjidil Haram dan Masjid Nabawi?",
    a: "Ya. Baba Tour menggunakan hotel terbaik di kelasnya sesuai paket yang dipilih. Informasi hotel dapat dilihat secara detail pada halaman masing-masing paket.",
  },

  {
    q: "Berapa lama proses visa umroh?",
    a: "Dalam kondisi normal, visa umroh dapat terbit sangat cepat dan bahkan dapat selesai dalam 1 hari kerja setelah seluruh persyaratan dokumen terpenuhi.",
  },

  {
    q: "Apakah program umroh ramah untuk lansia?",
    a: "Ya. Banyak jamaah Baba Tour merupakan lansia. Tim kami akan membantu sejak proses keberangkatan, pelaksanaan ibadah hingga kepulangan agar perjalanan lebih nyaman dan aman.",
  },

  {
    q: "Apakah anak-anak dapat ikut umroh bersama orang tua?",
    a: "Tentu. Paket umroh Baba Tour ramah untuk keluarga dan anak-anak. Tim kami akan membantu memberikan informasi kebutuhan dokumen dan fasilitas yang sesuai.",
  },

  {
    q: "Apakah Baba Tour resmi dan berizin Kemenag?",
    a: "Ya. Baba Tour merupakan penyelenggara perjalanan ibadah yang memiliki izin resmi PPIU dan PIHK dari Kementerian Agama Republik Indonesia.",
  },
];
